import React, { Component } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";

import Checkbox from "@material-ui/core/Checkbox";
import Collapse from "@material-ui/core/Collapse";
import Grid from "@material-ui/core/Grid";
import IconButton from "@material-ui/core/IconButton";
import Menu from "@material-ui/core/Menu";
import MenuItem from "@material-ui/core/MenuItem";
import Paper from "@material-ui/core/Paper";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import Typography from "@material-ui/core/Typography";

import MoreVertIcon from "@material-ui/icons/MoreVert";
import StarIcon from "@material-ui/icons/Star";
import StarBorderIcon from "@material-ui/icons/StarBorder";

import _ from "lodash";
//actions
import * as shootActions from "../../../../redux/actions/shootsactions";
import { computeShotStatusColor } from "../../../../utils/colorUtils";

class ShootsTable extends Component {
  //TODO
  // table cell width must be dynamic based on the value of the
  // prop "type" P.S find a way to code that.

  constructor(props) {
    super(props);
    this.state = {
      selectedRow: null,
      selectedMenu: null
    };
  }

  handleSelectRow(selectedRow) {
    if (this.state.selectedRow) {
      selectedRow.shot_id === this.state.selectedRow.shot_id
        ? this.setState({ selectedRow: null, selectedMenu: null })
        : this.setState({ selectedRow });
    } else {
      this.setState({ selectedRow });
    }
  }

  cellStyle = {
    display: "inline-block",
    position: "relative",
    width: "100%",
    whiteSpace: "nowrap",
    overflow: "hidden",
    textOverflow: "ellipsis"
  };

  handleCheckbox = index => {
    this.props.shootActions.handleCheckbox(index, this.props.type);
  };

  handlePriorityCheckbox = (id, priority) => {
    //shot_type, id, priority, newPriority, clinic, created_at;
    let { type } = this.props;
    let { date, name} = this.props.match.params;
    // console.log(type, id, priority, !priority, name, date);
    this.props.shootActions.updateShotPriority(type,id,priority,!priority,name,date)
  };

  formatStatus = shot => {
    let { approved, completed, checked, undoable } = shot;

    if (checked) {
      if (approved) return "REJECTED";
      //red
      else return "APPROVED"; //green
    } else {
      if (completed || undoable) return "CHECKING";
      else return "PENDING";
    }
  };

  render() {
    const tableHeaders = this.props.check ? (
      <React.Fragment>
        <TableCell style={{ width: "5%" }} padding="checkbox" onClick={this.props.handleSelectedAll}>
          <Checkbox checked={this.props.selectedAll} />
        </TableCell>
        <TableCell style={{ width: this.props.shot_type === "video" ? "15%" : " 15%" }}>Priority</TableCell>
        <TableCell style={{ width: this.props.shot_type === "video" ? "15%" : " 15%" }}>Scene</TableCell>
        <TableCell style={{ width: this.props.shot_type === "video" ? "15%" : " 25%" }}>Description</TableCell>
        <TableCell style={{ width: this.props.shot_type === "video" ? "15%" : " 15%" }}>Location</TableCell>
        <TableCell style={{ width: this.props.shot_type === "video" ? "15%" : " 15%" }}>Angle</TableCell>
        <TableCell style={{ width: this.props.shot_type === "video" ? "15%" : " 15%" }}>Framing</TableCell>
        {this.props.type === "video" ? <TableCell style={{ width: "10%" }}>Camera Movement</TableCell> : null}
        <TableCell style={{ width: "10%" }}>Status</TableCell>
      </React.Fragment>
    ) : (
      <React.Fragment>
        {this.props.edit ? (
          <TableCell style={{ width: "10%" }} padding="checkbox" onClick={this.props.handleSelectedAll}>
            <Checkbox checked={this.props.selectedAll} />
          </TableCell>
        ) : null}
        <TableCell
          style={{
            width: this.props.edit ? (this.props.shot_type === "video" ? "10%" : "15%") : this.props.shot_type === "video" ? "10%" : " 15%"
          }}
        >
          {/* {this.props.editPriority && <Checkbox color="primary" checkedIcon={<StarIcon />} icon={<StarBorderIcon />} />} */}
          Priority
        </TableCell>
        <TableCell
          style={{
            width: this.props.edit ? (this.props.shot_type === "video" ? "10%" : "15%") : this.props.shot_type === "video" ? "10%" : " 15%"
          }}
        >
          Scene
        </TableCell>
        <TableCell
          style={{
            width: this.props.edit ? (this.props.shot_type === "video" ? "30%" : "30%") : this.props.shot_type === "video" ? "30%" : " 40%"
          }}
        >
          Description
        </TableCell>
        <TableCell
          style={{
            width: this.props.edit ? (this.props.shot_type === "video" ? "10%" : "15%") : this.props.shot_type === "video" ? "15%" : " 15%"
          }}
        >
          Location
        </TableCell>
        <TableCell
          style={{
            width: this.props.edit ? (this.props.shot_type === "video" ? "15%" : "15%") : this.props.shot_type === "video" ? "15%" : " 15%"
          }}
        >
          Angle
        </TableCell>
        <TableCell
          style={{
            width: this.props.edit ? (this.props.shot_type === "video" ? "10%" : "15%") : this.props.shot_type === "video" ? "15%" : " 15%"
          }}
        >
          Framing
        </TableCell>
        {this.props.type === "video" ? <TableCell style={{ width: this.props.edit ? "15%" : "15%" }}>Camera Movement</TableCell> : null}
        {this.props.status === "PENDING" ? (
          <TableCell
            style={{
              width: this.props.edit ? (this.props.shot_type === "video" ? "10%" : "15%") : this.props.shot_type === "video" ? "15%" : " 15%"
            }}
          >
            Status
          </TableCell>
        ) : null}
        {/* <TableCell style={{ width: '10%'}}>Status</TableCell> */}
      </React.Fragment>
    );

    const tableRows = this.props.data.map((shot, index) => {
      let selectedRow;
      if (this.state.selectedRow) {
        selectedRow = this.state.selectedRow.shot_id === shot.shot_id ? true : false;
      } else {
        selectedRow = false;
      }
      return (
        <TableBody key={shot.shot_id}>
          <TableRow hover>
            {this.props.edit || this.props.check ? (
              <TableCell padding="checkbox">
                <Checkbox onClick={() => this.handleCheckbox(index)} checked={shot.selected} />
              </TableCell>
            ) : null}
            {this.props.editPriority ? (
              <TableCell padding="checkbox">
                <Checkbox
                  color="primary"
                  onClick={() => this.handlePriorityCheckbox(shot.shot_id, shot.priority)}
                  checked={shot.priority}
                  checkedIcon={<StarIcon />}
                  icon={<StarBorderIcon />}
                  disabled={this.props.updating}
                />
              </TableCell>
            ) : (
              <TableCell>
                {shot.priority ? <StarIcon style={{ color: "rgb(241, 196, 15)" }} /> : <StarBorderIcon style={{ color: "rgb(241, 196, 15)" }} />}
              </TableCell>
            )}
            <TableCell>
              <div style={this.cellStyle}>{shot.scene}</div>
            </TableCell>
            <TableCell>
              <div style={this.cellStyle}>{shot.description}</div>
            </TableCell>
            <TableCell>
              <div style={this.cellStyle}>{shot.location}</div>
            </TableCell>
            <TableCell>
              <div style={this.cellStyle}>{shot.angle}</div>
            </TableCell>
            <TableCell>
              <div style={this.cellStyle}>{shot.framing}</div>
            </TableCell>
            {this.props.type === "video" ? (
              <TableCell>
                <div style={this.cellStyle}>Static</div>
              </TableCell>
            ) : null}
            <TableCell>
              <div style={_.assign({}, this.cellStyle, computeShotStatusColor(this.formatStatus(shot)))}>{this.formatStatus(shot)}</div>
            </TableCell>
          </TableRow>
          <TableRow style={{ height: 0 }}>
            <TableCell colSpan={5} style={{ height: 0, border: "0px", padding: 0 }}>
              <Collapse in={false}>
                <Paper
                  style={{
                    position: "relative",
                    padding: "20px 20px",
                    margin: "20px 20px",
                    overflowX: "auto"
                  }}
                >
                  <div style={{ position: "absolute", top: 5, right: 5 }}>
                    <IconButton aria-label="More" aria-haspopup="true">
                      <MoreVertIcon />
                    </IconButton>
                    <Menu
                      id="long-menu"
                      anchorOrigin={{
                        vertical: "top",
                        horizontal: "right"
                      }}
                      transformOrigin={{
                        vertical: "top",
                        horizontal: "right"
                      }}
                    >
                      <MenuItem>View more</MenuItem>
                      <MenuItem>Edit</MenuItem>
                      <MenuItem>Delete</MenuItem>
                    </Menu>
                  </div>
                  <Grid container>
                    <Grid item xs={12} md={12} sm={12}>
                      <Typography variant="h5">Description</Typography>
                      <Typography variant="subtitle1" gutterBottom style={{ paddingLeft: 10 }}>
                        {shot.description}
                      </Typography>
                    </Grid>
                    <Grid item xs={12} md={4} sm={6}>
                      <Typography variant="h5">Scene</Typography>
                      <Typography variant="subtitle1" gutterBottom style={{ paddingLeft: 10 }}>
                        {shot.scene}
                      </Typography>
                    </Grid>
                    <Grid item xs={12} md={4} sm={6}>
                      <Typography variant="h5">Location</Typography>
                      <Typography variant="subtitle1" gutterBottom style={{ paddingLeft: 10 }}>
                        {shot.location}
                      </Typography>
                    </Grid>
                    <Grid item xs={12} md={4} sm={6}>
                      <Typography variant="h5">Angle</Typography>
                      <Typography variant="subtitle1" gutterBottom style={{ paddingLeft: 10 }}>
                        {shot.angle}
                      </Typography>
                    </Grid>
                    <Grid item xs={12} md={4} sm={6}>
                      <Typography variant="h5">Framing</Typography>
                      <Typography variant="subtitle1" gutterBottom style={{ paddingLeft: 10 }}>
                        {shot.framing}
                      </Typography>
                    </Grid>
                  </Grid>
                </Paper>
              </Collapse>
            </TableCell>
          </TableRow>
        </TableBody>
      );
    });

    return (
      <Table style={{ tableLayout: "fixed" }}>
        <TableHead>
          <TableRow>{tableHeaders}</TableRow>
        </TableHead>
        {tableRows}
      </Table>
    );
  }
}

const mapDispatchToProps = dispatch => {
  return {
    shootActions: bindActionCreators(shootActions, dispatch)
  };
};

export default connect(null, mapDispatchToProps)(ShootsTable);
